import React from 'react'

// components
import MobileLogoHeader from 'components/shared/LogoHeader/MobileHeader'

const getGreeting = ({ account, loading }) => {
  if (account) {
    return `Hi, ${account.user.firstName}`
  }

  if (loading) {
    return 'Loading…'
  }

  // new account
  return null
}

const MobileHeader = props => {
  const { account, title, loading, nav } = props
  const greeting = getGreeting({ account, loading })

  return <MobileLogoHeader title={title} greeting={greeting} nav={nav} />
}

export default MobileHeader
